module.exports = __webpack_public_path__ + "img/living.94a2f120.gif";